var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 44,
    viewBox: "0 0 35 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 9",
    d: "M34.5201 38.5268C34.7522 38.8549 34.6751 39.3102 34.3393 39.5311C31.7128 41.2594 28.737 42.3934 25.6202 42.8497C22.2631 43.3412 18.8375 43.0327 15.6222 41.9493C12.407 40.8659 9.4932 39.0382 7.11824 36.6152C4.74327 34.1921 2.97432 31.2423 1.95551 28.006C0.936704 24.7698 0.696855 21.3386 1.25551 17.992C1.81416 14.6455 3.15552 11.4782 5.17028 8.74837C7.18505 6.0185 9.81623 3.80322 12.8495 2.28301C15.6656 0.87161 18.7543 0.0964203 21.8972 0.00843535C22.299 -0.0028127 22.6231 0.326201 22.6207 0.728142C22.6184 1.13008 22.2905 1.45265 21.8888 1.46489C18.9752 1.55359 16.1128 2.27565 13.5016 3.58431C10.6734 5.00178 8.22004 7.06735 6.34144 9.61273C4.46283 12.1581 3.21213 15.1113 2.69123 18.2317C2.17033 21.3521 2.39397 24.5514 3.34392 27.569C4.29388 30.5865 5.94328 33.337 8.15775 35.5963C10.3722 37.8555 13.0891 39.5597 16.087 40.5699C19.085 41.5801 22.2792 41.8678 25.4093 41.4095C28.2992 40.9864 31.0591 39.9385 33.4981 38.3422C33.8344 38.122 34.2879 38.1986 34.5201 38.5268Z",
    fill: "#F07030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse1);
export default __webpack_public_path__ + "static/media/ellipse-1.0f06b2c20dcbf08701841c7d9945cb2e.svg";
export { ForwardRef as ReactComponent };